/* eslint-disable */
import moment from 'moment';
import { apiRequest } from '@/calls/helpers';

const getAttractions = async (params) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/agenda/attractions',
      data: { ...params }
    });

    // eslint-disable-next-line
    const events = request.response.map(event => {
      const start = moment(event.firstevent_date).format('DD.MM.YYYY');
      const end = moment(event.lastevent_date).format('DD.MM.YYYY');
      return {
        id: event.id,
        title: event.label,
        description: event.description,
        headline: event.categories.length ? event.categories[0].label : null,
        picture: event.image_url,
        date: {
          start: event.firstevent_date,
          end: start === end ? null : event.lastevent_date
        },
        liked: false,
        likes: 0,
        data: event
      };
    });

    for (let i = 0; i < events.length; i++) {
      const event = events[i];
      const req = await apiRequest('likes.php', {
        event: event.id
      });

      if (req && req.success && req.total) {
        event.likes = req.total;
      }
    }

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: events
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getCategories = async () => {
  try {

    const request = await apiRequest('sapiti.php',{
      method: 'GET',
      endpoint: '/agenda/attractions/categories'
    });

    const categories = request.response.map(cat => {
      cat.value = cat.id;
      return cat;
    });

    categories.push({
      id: 'streams',
      label: 'Streaming',
      value: 'streams'
    });

    categories.sort((a, b) => {
      if (a.label < b.label) { return -1; }
      if (a.label > b.label) { return 1; }
      return 0;
    });

    return {
      success: request.proxy_success,
      error: request.proxy_error,
      data: categories
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getStreams = async (params) => {
  try {
    const request = await apiRequest('sapiti.php', {
      method: 'GET',
      endpoint: '/catalogue/streams',
      data: { ...params }
    });

    const today = new Date();
    const data = request.response.filter(stream => stream.starttime).map(stream => {
      const start = moment(stream.starttime).format('DD.MM.YYYY');
      const end = moment(stream.endtime).format('DD.MM.YYYY');
      return {
        id: stream.id,
        stream: true,
        title: stream.label,
        description: stream.description,
        headline: 'Streaming',
        picture: stream.attraction.image_url,
        date: {
          start: stream.starttime,
          end: start === end ? null : stream.endtime
        },
        liked: false,
        likes: 0,
        data: stream
      };
    }).filter(stream => {
      let date = stream.data.endtime ? new Date(stream.data.endtime) : new Date(stream.data.starttime);
      return date > today;
    });

    return {
      success: true,
      data
    };
  } catch (error) {
    return {
      error: true,
      data: error
    };
  }
};

const getHomeList = async (paramsAttractions, paramsStreams) => {
  try {
    const reqAttractions = paramsAttractions ? await getAttractions(paramsAttractions) : null;
    const reqStreams = paramsStreams ? await getStreams(paramsStreams) : null;

    let attractions = [];
    let streams = [];
    if (reqAttractions && reqAttractions.success) {
      attractions = reqAttractions.data;
    }

    if (reqStreams && reqStreams.success) {
      streams = reqStreams.data;
    }

    return {
      success: true,
      data: {
        attractions,
        streams
      }
    };
  } catch (error) {
    return {
      error: true,
      data: error
    }
  }
};

export {
  // eslint-disable-next-line
  getAttractions,
  getCategories,
  getStreams,
  getHomeList
};
